var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 105,
    viewBox: "0 0 106 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 105C81.9949 105 105.5 81.4949 105.5 52.5C105.5 23.5051 81.9949 0 53 0C24.0051 0 0.5 23.5051 0.5 52.5C0.5 81.4949 24.0051 105 53 105Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8157 27.6687H40.3184V77.5848H77.8843V27.6687H75.8157ZM75.8157 75.4855H42.387V29.7373H75.8157V75.4855Z",
    fill: "#572580"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1252 40.2881H45.3945V41.6569H72.1252V40.2881Z",
    fill: "#572580"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1252 42.8721H45.3945V44.2409H72.1252V42.8721Z",
    fill: "#572580"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1252 45.4558H45.3945V46.8246H72.1252V45.4558Z",
    fill: "#572580"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1252 48.0398H45.3945V49.4086H72.1252V48.0398Z",
    fill: "#572580"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1252 50.6236H45.3945V51.9925H72.1252V50.6236Z",
    fill: "#572580"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1252 53.1998H45.3945V54.5686H72.1252V53.1998Z",
    fill: "#572580"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1252 55.7837H45.3945V57.1525H72.1252V55.7837Z",
    fill: "#572580"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1252 58.3675H45.3945V59.7363H72.1252V58.3675Z",
    fill: "#572580"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1252 60.9514H45.3945V62.3202H72.1252V60.9514Z",
    fill: "#572580"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1252 63.5352H45.3945V64.9041H72.1252V63.5352Z",
    fill: "#572580"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1252 66.1191H45.3945V67.4879H72.1252V66.1191Z",
    fill: "#572580"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1252 68.6953H45.3945V70.0641H72.1252V68.6953Z",
    fill: "#572580"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1252 71.2791H45.3945V72.6479H72.1252V71.2791Z",
    fill: "#572580"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8838 33.4594H45.3945V35.5281H55.8838V33.4594Z",
    fill: "#F6E71C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3662 36.0125H45.3945V38.0812H63.3662V36.0125Z",
    fill: "#F6E71C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1133 73.394V28.9377H36.0352V73.394",
    fill: "#F6E71C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0745 73.3939H35.0059V29.9759H33.1526V73.3939H31.084V27.9072H37.0745V73.3939Z",
    fill: "#572580"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2051 54.9453H32.4062V57.0139H36.2051V54.9453Z",
    fill: "#572580"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2051 51.9695H32.4062V54.0381H36.2051V51.9695Z",
    fill: "#572580"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0999 46.7864H28.0312V31.2678H36.6903V33.3364H30.0999V46.7864Z",
    fill: "#572580"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0352 73.909V73.4553H32.1133V73.909V74.4243L33.0976 77.9156H35.0586L36.0352 74.4243V73.909Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8441 78.9461H32.3144L31.084 74.5705V72.4172H37.0745V74.5705L35.8441 78.9461ZM33.8524 76.8775H34.2446L34.9213 74.4859H33.2141L33.8524 76.8775Z",
    fill: "#572580"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationIcon);
export default __webpack_public_path__ + "static/media/validationIcon.03c1467b4616c8f46d0096474437c2ff.svg";
export { ForwardRef as ReactComponent };